export const SITE_KEY_FOR_CAPTCHA = "6LcEc4keAAAAAJRnL3JBGeOzcC8wrS8Y8EFZIL5X";
export const SITE_KEY_FOR_GOOGLE = "752871334409-7sqb58pqbfb9ulfnk2a1e4qeuidsjde7.apps.googleusercontent.com"
export const SITE_KEY_FOR_FACEBOOK = "329509335853785"
